import React from 'react'

import { Role, useGetViewerQuery } from '@/generated/graphql'

export const useGetRoles = () => {
  const { data } = useGetViewerQuery()

  return React.useMemo(() => data!.viewer.roles.map(({ role }) => role), [data])
}

export const useIsRootAdmin = () => {
  const roles = useGetRoles()
  return roles.includes(Role.RootAdmin)
}

export const useIsSystemAdmin = () => {
  const roles = useGetRoles()
  return roles.includes(Role.SystemAdmin)
}

export const useIsHR = () => {
  const HRIds = [997]
  const { data } = useGetViewerQuery()
  return HRIds.includes(data!.viewer.userId)
}
